(function () {
  'use strict';

  angular
    .module('vcdms.vcpdfprinter')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcdmspdfprinter', {
        url: '/vcdmspdfprinter',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;pdfprintersearch pdfprinter="" pdfprinterref="" editinplace="true"&gt;</tt></h3><div ui-view="pdfprintersearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;pdfprintersearch pdfprinter="" pdfprinterref="" parentsave=""&gt;</tt></h3><div ui-view="pdfprintersearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;pdfprintereditor pdfprinter="" mode="" onClose=""&gt;</tt></h3><div ui-view="pdfprintereditview"></div>
              <h3 class="alert alert-info"><tt>&lt;pdfprinternew&gt;</tt></h3><div ui-view="pdfprinternewview"></div>
              <h3 class="alert alert-info"><tt>&lt;pdfprinterlist pdfprinters="?"&gt;</tt></h3><div ui-view="pdfprinterlistview"></div>
            `
          }
        },
        onEnter: function () {
          $log.debug('debug/routes - playground.vcdmsvcpdfprinter entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcdmspdfprinter.allcomponents', {
        url: '/allcomponents',
        resolve: {
          pdfprinter: function () {
            return '';
          },
          pdfprinterref: function () {
            return '';
          },
          somepdfprinter: function (Pdfprinter) {
            return Pdfprinter.$find('572b31b07c01597e3e150923');
          },
          allpdfprinters: function (Pdfprinter) {
            return Pdfprinter.$search({active: true});
          },
          parentsavesearch: function () {
            return function (pdfprinter, pdfprinterref) {
              console.log('debug: dummy parentsave called for pdfprintersearch with: ', pdfprinter, pdfprinterref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'pdfprintersearchview@playground.vcdmspdfprinter': {
            component: 'pdfprintersearch',
            bindings: {
              pdfprinter: 'pdfprinter',
              pdfprinterref: 'pdfprinterref',
              editinplace: 'eip'
            }
          },
          'pdfprintersearchview2@playground.vcdmspdfprinter': {
            component: 'pdfprintersearch',
            bindings: {
              pdfprinter: 'pdfprinter',
              pdfprinterref: 'pdfprinterref',
              parentsave: 'parentsavesearch'
            }
          },
          'pdfprintereditview@playground.vcdmspdfprinter': {
            component: 'pdfprintereditor',
            bindings: {
              pdfprinter: 'somepdfprinter'
            }
          },
          'pdfprinternewview@playground.vcdmspdfprinter': {
            component: 'pdfprinternew',
            bindings: {
            }
          },
          'pdfprinterlistview@playground.vcdmspdfprinter': {
            component: 'pdfprinterlist',
            bindings: {
              pdfprinters: 'allpdfprinters'
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcdmspdfprinter.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());
